import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Icon,
  Menu,
  Dropdown,
  Col,
  Input,
  Popover,
  Select,
  Button,
  Badge,
  Modal,
  Tabs,
  message
} from 'antd';
import {
  TabMenuContainer,
  EmptySettingsDetails,
  HelpGuideWrapper,
  LoaderContainer,
  TabMenuHeaderContainer,
  TabMenuHeader,
  TabMenuItemContainer,
  SubTabHeading,
  DropdownDetails,
  NoDataView,
  TabSearchContainer,
  PopoverContainer,
  ClearAll,
  NoteText,
  ModalBody,
  SearchNavWrapper,
} from './../../containers/SidebarMenu/styles';
import ComplexPreviewModal from '../../components/Modals/ComplexPreviewModal';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import { FilterSvg } from '../../components/SidebarMenuIcons';
import { withTranslation } from 'react-i18next';
import Loader from '../../components/Loader';
import EditorElement from './../../components/EditorElement/index';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import {
  getAllDocumentsByCategories,
} from '../../utils/services/categoriesAPI';
import {
  getTemplateStatus,
  searchDocuments,
} from '../../utils/services/templatesAPI';
import AddTagsModal from '../../components/Modals/AddTagsModal';

// // app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import TemplateMenuItem from './../../containers/SidebarMenu/TemplateMenuItem';
import {
  DESIGN_AREA_TEMPLATES_TAB,
  TEMPLATE_LOCKED_BY_MODAL,
} from './../../containers/SidebarMenu/translationValues';
import { ApplyTemplateBtn, ApplyTemplateBtnContainer } from '../../components/ApplyTemplate/styles';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';
import { fetchManageTags } from '../../utils/services/complexDocumentsAPI';
import { useArtboardContext, CONTEXT_KEYS, TEMPLATE_TYPE } from '../../context/complexArtboardContext';
import { getMasterlanguageList, getMasterDocument, getMasterDocumentByCategory } from '../../utils/services/complexDocumentsAPI';
import { getAllLanguage } from '../../utils/services/languageApi';
import { addUuidToAllBlocksInDocument, getAllBlocksInDocument, removeCurrentBusinessLogics, updateMasterTemplateToDocument } from '../../utils/masterTemplateHelper';
import { BusinessLogic } from '../../context/businessLogicContext';
import { updateBusinessLogic } from '../../utils/services/businessLogicApi';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { buildBusinessLogicMaps, SUPPORT_EMAIL_ID } from '../../utils/helper';
import { CREATE_NEW_TEMPLATE_MODAL } from '../../components/CreateNewTemplate/translationValues';
import axios from 'axios';
import _ from 'underscore';
import { getComplexDocument } from '../../utils/services/complexDocumentsAPI';
import { COMPLEX_DOCUMENT_VERSION } from '../../utils/complexDocumentConstants';
import { FullPageLoaderContainer } from '../../artboard/styles';
import { handleBusinessLogic } from './complexDocumentHelper';
const { Option } = Select;
const { TabPane } = Tabs;
const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB', 'TEMPLATE_LOCKED_BY_MODAL', 'CREATE_NEW_TEMPLATE_MODAL'];

const ComplexTemplateTab = props => {
  const {
    isBottom,
    isSelectionMode = false,
    setIsBottom,
    onSelect,
    activetabIndex,
    attachmentTemp,
    t,
  } = props;
  const customSelector = useCallback(() => null, []);
  const [, methods] = useDocumentContext(customSelector, 'ComplexTemplateTab');

  const getAddTagSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.TAGS], []);
  const [, store] = useDocumentContext(getAddTagSelector, `ComplexTemplateTab`);

  const [selectedView, setSelectedView] = useState('view-templates');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedMasterVariables, setSelectedMasterVariables] = useState();
  const [fetchingCategories, setFetchingCategories] = useState(true);
  const [initialLoader, setInitialLoader] = useState(true);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const {
    categoryTemplates,
    updateCategoryTemplates,
    isEnterprise,
    checkUserAccess,
    userDetails,
  } = useContext(AppStoreContext);
  const { businessLogics, setBusinessLogics } = useContext(BusinessLogic);
  const [loadMore, setLoadMore] = useState(false);
  const [page, setPage] = useState(1);
  const [previousView, setPreviousView] = useState('view-templates');
  const [defaultTemplates, setDefaultTemplates] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [searchedTemplates, setSearchedTemplates] = useState({});
  const [noData, setNodata] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterOption, setFilterOption] = useState('All');
  const [lockedBy, setLockedBy] = useState({});
  const [templateType, settemplateType] = useState(
    checkUserAccess('master') ? 'mastertemplate' : 'usertemplate',
  );
  const [tagList, setTagList] = useState('');
  const [isCheckingLimit, setIsCheckingLimit] = useState(false);
  const [documentLimit, setDocumentLimit] = useState(null);
  const [planName, setPlanName] = useState('');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  let history = useHistory();

  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [CurrentDesign] = useArtboardContext(getCurrentDesign);

  const editableSelector = useCallback(store => store[CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN], []);
  const [editable] = useArtboardContext(editableSelector, 'ComplexArtboard');

  const [languageList, setLanguageList] = useState([]);
  const [selectedTab, setSelectedTab] = useState('MyDesigns');
  const [selectedLanguages, setSelectedLangues] = useState(undefined);
  const [languageOption, setLanguageOption] = useState('All');
  const [fetchingLanguage, setFetchingLanguage] = useState(true);
  const [showPreviewLoader, setShowPreviewLoader] = useState(false);
  const cancelTokenRef = useRef();
  const isMasterTab = selectedTab === 'Master';

  useEffect(() => {
    (async () => {
      await myDesignFilterOption()
    })();
    // eslint-disable-next-line
  }, [templateType, isSelectionMode]);

  useEffect(() => {
    if (isBottom && !loadMore && !noData) {
      if (selectedView === 'view-search-template') {
        onSearch();
      }
    }
    setDefaultTemplates(categoryTemplates);
    // eslint-disable-next-line
  }, [isBottom, categoryTemplates, templateType]);

  const onScroll = e => {
    if (!setIsBottom) return;
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    if (Math.abs(scrollTop + clientHeight - scrollHeight) < 10) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  };

  const handleMasterTemplateSelection = async templateObj => {
    try {
      const payload = { draftDocumentId: templateObj.id };
      const response = await getMasterDocument(payload);
      if (response?.data?.length) {
        const masterResponse = response.data[0];
        const variables = masterResponse.variables;
        const masterTemplate = masterResponse.documentDTO;
        setSelectedMasterVariables(variables);
        setSelectedTemplate(masterTemplate);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getDocumentDetails = async (id = '', isPreview = false) => {
    try {
      isPreview && setShowPreviewLoader(true);
      !isPreview && setInitialLoader(true);
      const response = await getComplexDocument(id, COMPLEX_DOCUMENT_VERSION.DRAFT, false);
      if (response?.statusCode === 707 && response?.data?.flows) {
        setSelectedTemplate(prev => {
          if (prev) {
            return {
              ...prev,
              flows: response.data.flows,
              isMasterTab: isMasterTab
            }
          }
          return prev;
        });
      }
      else {
        updateSelectedView('view-templates', null);
        message.error(t(DESIGN_AREA_TEMPLATES_TAB.DOCUMENT_FETCH_FAIL_MESSAGE.key, DESIGN_AREA_TEMPLATES_TAB.DOCUMENT_FETCH_FAIL_MESSAGE.value))
      }
      setInitialLoader(false)
    }
    catch (err) {
      setInitialLoader(false)
      updateSelectedView('view-templates', null);
      message.error(t(DESIGN_AREA_TEMPLATES_TAB.DOCUMENT_FETCH_FAIL_MESSAGE.key, DESIGN_AREA_TEMPLATES_TAB.DOCUMENT_FETCH_FAIL_MESSAGE.value))
    }
  }

  const updateSelectedView = (view, templateObj, action = undefined) => {
    if (view === 'view-templates') {
      setSearchKey('');
      setFilterOption('All');
      setLanguageOption('All')
      setSelectedCategory(undefined);
      setSearchedTemplates({});
      updateCategoryTemplates(defaultTemplates, 'saveAllCategoryTemplates');
    }
    if (action) {
      setPreviousView(action);
    }
    setSelectedView(view);
    if (templateObj && selectedTab === 'Master') {
      handleMasterTemplateSelection(templateObj);
    } else {
      setSelectedTemplate(() => templateObj);
      templateObj && getDocumentDetails(templateObj.id);
    }
  };

  const checkTemplateStatus = async template => {
    const templateStatus = await getTemplateStatus(template.id, 'printTemplate');
    if (templateStatus?.data) {
      const { locked, lockedBy } = templateStatus.data;
      if (userDetails && locked && lockedBy) {
        const locked = userDetails.id !== lockedBy.userId;
        if (locked) {
          setLockedBy(lockedBy);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }
  };


  useEffect(() => {
    if (selectedAction === "open_addTag_modal") {
      setSelectedAction("add-tag");
    }
  }, [selectedAction])

  const enableModalVisibility = async (actionType, template) => {
    const checkStatus = ['delete-template', 'add-tag'].some(data => data === actionType);
    setSelectedTemplate(template);
    if (checkStatus) {
      actionType = (await checkTemplateStatus(template)) || actionType;
    }
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);


    if (actionType === "add-tag") {
      const payload = { id: template.id, type: 'document' }
      const fetchTagsResponse = await fetchManageTags(payload);
      if (fetchTagsResponse?.statusCode === 1901) {
        setTagList(fetchTagsResponse.data.tags);
        setSelectedAction("open_addTag_modal");
      }
      else {
        message.error(t(DESIGN_AREA_TEMPLATES_TAB.FETCHING_RECORDS_ERROR_MESSAGE.key, DESIGN_AREA_TEMPLATES_TAB.FETCHING_RECORDS_ERROR_MESSAGE.value))
      }
    }
  };

  const previewModalVisibility = async (e, actionType, template, pageId) => {
    e.stopPropagation();
    setSelectedAction(actionType);
    setSelectedTemplate(template);
    selectedTab === 'MyDesigns' && template && await getDocumentDetails(template.id, true);
    setShowPreviewLoader(false);
    setUpdateModalVisibility(true);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
  };

  const redirectToTemplate = async (template, actionType, updates) => {
    if (template?.documentId) {
      history.push(`/design/${template.documentId}`);
    }
    setUpdateModalVisibility(false);
    setSelectedAction(null);
  };

  const onSuccessDeletion = () => {
    setSelectedView('view-templates');
    setUpdateModalVisibility(false);
  };

  const onSearch = async (first = false, category = selectedCategory, searchParam = searchKey, languages = selectedLanguages) => {
    setInitialLoader(true);
    let currentPage = page;
    if (first) {
      setPage(1);
      currentPage = 1;
      setNodata(false);
      setFetchingCategories(true);
    }
    const payload = {
      includeFlows: selectedTab === 'MyDesigns' ? false : true,
    };
    if (searchParam !== '') {
      payload.searchParam = searchParam;
    }
    if (category?.categoryId) {
      payload.categoryId = category?.categoryId
    }
    if (languages?.code && selectedTab === 'Master') {
      payload.language = languages?.code
    }
    if (languages?.code && selectedTab === 'MyDesigns') {
      payload.languages = languages?.code
    }

    setSelectedView('view-search-template');
    setLoadMore(true);    
    const response =  selectedTab === 'Master' ? await getMasterDocument(payload) : await searchDocuments(payload, templateType, isSelectionMode);
    if (response?.data) {
      const templates = response.data;
      let updatedSearchTemplates = {
        count: response.dataCount,
        templates: first ? templates : [...searchedTemplates?.templates, ...templates],
      };
      setSearchedTemplates(updatedSearchTemplates);
      if (payload.limit * currentPage >= response.dataCount) {
        setNodata(true);
      }
      setPage(currentPage + 1);
    }
    setFetchingCategories(false);
    setLoadMore(false);
    setInitialLoader(false);
  };

  const seeAllByCategory = (category, language) => {
    if (category === 'All' && language === 'All') {
      updateSelectedView('view-templates', null);
    } else {
      setSelectedCategory(category);
      setSelectedLangues(language)
      onSearch(true, category, searchKey, language);
    }
  };

  const onClose = () => {
    setSearchKey('');
    if (!selectedCategory) {
      updateSelectedView('view-templates', null);
    } else {
      onSearch(true, undefined, '');
    }
  };

  const onSuccessAddition = success => {
    if (success && (searchKey.length > 0 || selectedCategory)) {
      onSearch(true);
    }
    setUpdateModalVisibility(false);
  };

  const renderLoader = (styles = {}) => (
    <LoaderContainer top={styles.top}>
      <Loader />
      <div className="loading-txt">
        {t(
          DESIGN_AREA_TEMPLATES_TAB.LOADING_MORE_TEMPLATES_TEXT.key,
          DESIGN_AREA_TEMPLATES_TAB.LOADING_MORE_TEMPLATES_TEXT.value,
        )}
      </div>
    </LoaderContainer>
  );

  const handleCreateTemplate = async () => {
    if(isEnterprise || checkUserAccess('master')) {
      enableModalVisibility('create-template', null);
      return;
    }
    try {
      setIsCheckingLimit(true);
      const response = await fetchPlanUsageDetails();
      if(response?.statusCode === 1918) {
        const { templateLimit: created } = response.data.usage;
        const { templateLimit: limit, planName } = response.data.upperLimit;
        if (created >= limit) {
          setDocumentLimit(limit);
          setPlanName(planName);
          setShowUpgradeModal(true);
        } else {
          enableModalVisibility('create-template', null);
        }
      }
    }
    catch(e) {
      console.error(e);
    }
    finally {
      setIsCheckingLimit(false);
    }
  }

  const renderSearchBar = () => {
    return (
      <TabSearchContainer
        marginTop
        Master={checkUserAccess('master')}
        inverted={isSelectionMode ? 1 : 0}
      >
        <Input
          name="templateSearch"
          placeholder={t(
            DESIGN_AREA_TEMPLATES_TAB.SEARCH_TEMPLATES_PLACEHOLDER.key,
            DESIGN_AREA_TEMPLATES_TAB.SEARCH_TEMPLATES_PLACEHOLDER.value,
          )}
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onPressEnter={() => onSearch(true)}
          style={{ width: 200 }}
          prefix={<Icon type="search" />}
          autoComplete={'off'}
          suffix={
            <>
              {searchKey.length > 0 && <Icon type="close" onClick={onClose} />}
              <Popover
                placement="bottomRight"
                title={t(
                  DESIGN_AREA_TEMPLATES_TAB.FILTER_POPUP_LABEL.key,
                  DESIGN_AREA_TEMPLATES_TAB.FILTER_POPUP_LABEL.value,
                )}
                trigger="click"
                visible={filterVisible}
                onVisibleChange={() => setFilterVisible(!filterVisible)}
                content={
                  <PopoverContainer>
                    <ClearAll
                      onClick={() => [
                        setFilterVisible(false),
                        updateSelectedView('view-templates', null),
                      ]}
                    >
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.CLEAR_ALL_FILTER_ACTION.key,
                        DESIGN_AREA_TEMPLATES_TAB.CLEAR_ALL_FILTER_ACTION.value,
                      )}
                    </ClearAll>

                    <div className='ant-popover-title title' style={{ padding: '8px 0px' }}>
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_CATEGORY_LABEL.key,
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_CATEGORY_LABEL.value,
                      )}
                    </div>
                    <Select   
                      loading={fetchingCategories}                   
                      showSearch
                      value={JSON.stringify(filterOption)}
                      style={{ width: 200 }}
                      placeholder="Select Category"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setFilterOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                        {t(
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.key,
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.value,
                        )}
                      </Option>
                      {defaultTemplates && defaultTemplates?.length > 0 &&
                        defaultTemplates.map(data => (
                          <Option key={data.categoryId} value={JSON.stringify(data)}>
                            {data.categoryName}
                          </Option>
                        ))}
                    </Select>

                    <div className='ant-popover-title title' style={{ padding: '8px 0px' }}>
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_LANGUAGE_LABEL.key,
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_LANGUAGE_LABEL.value,
                      )}</div>
                    <Select
                      loading={fetchingLanguage}
                      showSearch
                      value={JSON.stringify(languageOption)}
                      style={{ width: 200 }}
                      placeholder="Select Category"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setLanguageOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                        {t(
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.key,
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.value,
                        )}
                      </Option>
                      {languageList.length > 0 &&
                        languageList.map(data => (
                          <Option key={data.code} value={JSON.stringify(data)}>
                            {data.name}
                          </Option>
                        ))}
                    </Select>

                    <Button
                      type="primary"
                      onClick={() => [setFilterVisible(false), seeAllByCategory(filterOption,languageOption)]}
                    >
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.APPLY_FILTERS_BUTTON.key,
                        DESIGN_AREA_TEMPLATES_TAB.APPLY_FILTERS_BUTTON.value,
                      )}
                    </Button>
                  </PopoverContainer>
                }
              >
                <Badge dot count={selectedCategory ? null : 0}>
                  <Icon component={FilterSvg} onClick={() => setFilterVisible(!filterVisible)} />
                </Badge>
              </Popover>
            </>
          }
        />
        {!fetchingCategories && selectedView === 'view-search-template' && (
          <NoteText>
            {t(
              DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_FOUND_COUNT.key,
              DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_FOUND_COUNT.value,
              { templatesCount: searchedTemplates?.count },
            )}
          </NoteText>
        )}
      </TabSearchContainer>
    );
  };

  const renderEmptyView = () => (
    <EmptySettingsDetails inverted={isSelectionMode ? 1 : 0}>
      <div className="empty-illustration">
        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
      </div>
      <div className="empty-txt">
        <span>
          {selectedTab === 'Master'?t(
            DESIGN_AREA_TEMPLATES_TAB.MASTER_TEMPLATES_EMPTY.key,
            DESIGN_AREA_TEMPLATES_TAB.MASTER_TEMPLATES_EMPTY.value,
          ): t(
            DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_LIST_EMPTY.key,
            DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_LIST_EMPTY.value,
          ) +
            `${isSelectionMode
              ? ''
              : t(DESIGN_AREA_TEMPLATES_TAB.CLICK.key, DESIGN_AREA_TEMPLATES_TAB.CLICK.value)
            }`}
        </span>
        {selectedTab !== 'Master' &&!isSelectionMode && (
          <>
            <span
              className="empty-links"
              onClick={handleCreateTemplate}
            >
              {t(DESIGN_AREA_TEMPLATES_TAB.HERE.key, DESIGN_AREA_TEMPLATES_TAB.HERE.value)}
            </span>
            <span>
              {t(
                DESIGN_AREA_TEMPLATES_TAB.EMPTY_LIST_CREATE_NEW_TEMPLATE.key,
                DESIGN_AREA_TEMPLATES_TAB.EMPTY_LIST_CREATE_NEW_TEMPLATE.value,
              )}
            </span>
          </>
        )}
      </div>
    </EmptySettingsDetails>
  );

  const tabHeaderView = category => {   
    return (
      <Col className={checkUserAccess('master') && 'masterTemplate'}>
        <TabMenuHeader
          inverted={isSelectionMode ? 1 : 0}
          className={attachmentTemp ? 'attachmentTemp' : 'categoryName'}
        >
          <h2>{category.categoryName}</h2>
        </TabMenuHeader>
        {category.documents && category.documents.length >= 4 && (
          <TabMenuHeader
            inverted={isSelectionMode ? 1 : 0}
            onClick={() => seeAllByCategory(category)}
          >
            <div className="see-all">
              {t(
                DESIGN_AREA_TEMPLATES_TAB.SEE_ALL_TEMPLATES_ACTION.key,
                DESIGN_AREA_TEMPLATES_TAB.SEE_ALL_TEMPLATES_ACTION.value,
              )}
            </div>
          </TabMenuHeader>
        )}
      </Col>
    );
  };

  const singleTemplate = (category, templateObj, action) => {
    let categoryByTemplate = {
      id: templateObj.id,
      name: templateObj.name,
      categoryName: category?.categoryName,
      categoryId: category?.categoryId,
      tags: templateObj.tags,
    };
    templateObj.categoryName = category?.categoryName;
    return (
      <TemplateMenuItem
        templateObj={templateObj}
        noCarousel={true}
        inverted={isSelectionMode ? 1 : 0}
        previewText={t(
          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.key,
          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.value,
        )}
        onMenuClick={e => {
          if (isSelectionMode && onSelect) {
            onSelect(templateObj);
          } else {
            updateSelectedView('view-template-pages', templateObj, action);
          }
        }}
        onPreviewClick={e => previewModalVisibility(e, 'preview-thumbnail', templateObj, 0)}
        renderDropDown={() =>
          isSelectionMode ? (
            <div />
          ) : (
              (checkUserAccess('client') || checkUserAccess('master')) && selectedTab === "MyDesigns") && ((
                <DropdownDetails
                  id={`${templateObj.id}-template`}
                  className="dropdown-menu"
                  onClick={e => e.stopPropagation()}
                >
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item key="0" onClick={() => redirectToTemplate(templateObj)}>
                          {t(
                            DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.key,
                            DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.value,
                          )}
                        </Menu.Item>
                        <Menu.Item
                          key="1"
                          onClick={() => enableModalVisibility('delete-template', categoryByTemplate)}
                        >
                          {t(
                            DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.key,
                            DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.value,
                          )}
                        </Menu.Item>
                        <Menu.Item
                          key="2"
                          onClick={() => enableModalVisibility('add-tag', categoryByTemplate)}
                        >
                          {t(
                            DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.key,
                            DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.value,
                          )}
                        </Menu.Item>
                      </Menu>
                    }
                    trigger={['click']}
                    getPopupContainer={() => document.getElementById(`${templateObj.id}-template`)}
                  >
                    <Icon type="more" />
                  </Dropdown>
                </DropdownDetails>
              )
            )
        }
        isComplex={true}
        languageList={languageList}
        isMasterTab={isMasterTab}
      />
    );
  };

  const templateCardView = (category, action) => {
    return category.documents && category.documents.length ? (
      <TabMenuItemContainer>
        {category.documents.map(templateObj => {
          return singleTemplate(category, templateObj, action);
        })}
      </TabMenuItemContainer>
    ) : (
      <div></div>
    );
  };

  const renderCategory = () => {
    return (
      <>
        {categoryTemplates.map(category => (
          <TabMenuHeaderContainer key={category.categoryId} firstElement>
            {tabHeaderView(category)}
            {templateCardView(category, 'view-templates')}
          </TabMenuHeaderContainer>
        ))}
      </>
    );
  };


  const handleApplyAllFlows = useCallback(
    _.throttle(async () => {
      if (selectedTab === 'Master') {
        updateMasterTemplateToDocument(store, selectedTemplate.id).then(
          async ({ flows, handleBusinessLogic, style }) => {
            const callback = ({ blockIdsMap, flowIdsMap }) => {
              const autosaveCallback = () => {
                // delete all business logics and replace it with business logics from master template
                removeCurrentBusinessLogics(businessLogics, setBusinessLogics);
                handleBusinessLogic && handleBusinessLogic(blockIdsMap, setBusinessLogics, false, flowIdsMap, flows);
              };
              methods.set({
                [COMPLEX_DOCUMENT_CONTEXT_KEYS.AUTOSAVE_CALLBACK]: autosaveCallback,
                [COMPLEX_DOCUMENT_CONTEXT_KEYS.NEW_LANGUAGE_CODE]: selectedTemplate?.language,
                [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_DRAG_ACTION]: true,
              });
            };
            methods.replaceDocument(flows, style, callback);
          },
        );
      } else {
        const flows = addUuidToAllBlocksInDocument(selectedTemplate.flows);
        const callback = ({ blockIdsMap, flowIdsMap }) => {
          const autosaveCallback = () => {
            // delete all business logics and replace it with business logics from mydesign template
            removeCurrentBusinessLogics(businessLogics, setBusinessLogics);
            handleBusinessLogic({ methods, selectedTemplate, setBusinessLogics, blockIdsMap, flowIdsMap });
          };
          methods.set({
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.AUTOSAVE_CALLBACK]: autosaveCallback,
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.NEW_LANGUAGE_CODE]: selectedTemplate?.language,
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_DRAG_ACTION]: true,
          });
        };

        methods.replaceDocument(flows, selectedTemplate.style, callback);
      }
    }, 5000),
    [selectedTab, selectedTemplate],
  );

  // this component renders template pages
  const renderTemplates = () => {
    return (
      <div>
        <SubTabHeading Master={checkUserAccess('master')} className="with-icon">
          <Icon type="left" onClick={() => updateSelectedView(previousView, null)} />
          <div className="subtab-name">{selectedTemplate.name}</div>
          {(checkUserAccess('client')
            ? selectedTemplate.type === 'usertemplate'
              ? true
              : false
            : selectedTemplate.type === 'mastertemplate'
              ? true
              : false) && (
              <DropdownDetails
                id={`${selectedTemplate.id}-template`}
                className="dropdown-menu dropdown-visible"
                onClick={e => e.stopPropagation()}
              >
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item key="0" onClick={() => redirectToTemplate(selectedTemplate)}>
                        {t(
                          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.key,
                          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.value,
                        )}
                      </Menu.Item>
                      <Menu.Item
                        key="1"
                        onClick={() => enableModalVisibility('delete-template', selectedTemplate)}
                      >
                        {t(
                          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.key,
                          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.value,
                        )}
                      </Menu.Item>
                      <Menu.Item
                        key="2"
                        onClick={() => enableModalVisibility('add-tag', selectedTemplate)}
                      >
                        {t(
                          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.key,
                          DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.value,
                        )}
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={['click']}
                  getPopupContainer={() => document.getElementById(`${selectedTemplate.id}-template`)}
                >
                  <Icon type="more" />
                </Dropdown>
              </DropdownDetails>
            )}
        </SubTabHeading>
        <ApplyTemplateBtnContainer>
          <ApplyTemplateBtn editable={editable} onClick={editable && _.debounce(handleApplyAllFlows, 500)}>{t(DESIGN_AREA_TEMPLATES_TAB.APPLY_ALL_PAGES_BUTTON.key, DESIGN_AREA_TEMPLATES_TAB.APPLY_ALL_PAGES_BUTTON.value)}</ApplyTemplateBtn>
        </ApplyTemplateBtnContainer>
        {selectedTemplate && selectedTemplate.flows?.length > 0 ? (
          <EditorElement
            element={selectedTemplate}
            clickElement={() => { }}
            toggleDragging={() => { }}
            pageSettings={{}}
            setIsDragAndDropped={() => { }}
            type={"replaceFlow"}
            cardType='replaceFlow'
            masterVariables={selectedMasterVariables}
          />
        ) : (
          <div></div>
        )}
      </div>
    );
  };

  const showMoreView = text => {
    const loaderStyles = { top: '0px' };
    return (
      <>
        {loadMore && renderLoader(loaderStyles)}
        {noData && <NoDataView small>{text}</NoDataView>}
      </>
    );
  };

  const renderSearchView = () => {  
    return searchedTemplates.templates?.length > 0 ? (
      <>
        <TabMenuItemContainer>
          {searchedTemplates.templates.map(data => {    
            const categoryDetails = {
              categoryId: data.categoryId,
              ...data.documentDTO
            };
            return singleTemplate(categoryDetails, selectedTab === 'Master' ? data.documentDTO : data, 'view-search-template');
          })}
        </TabMenuItemContainer>
        {showMoreView(
          t(
            DESIGN_AREA_TEMPLATES_TAB.GOT_ALL_RESULTS.key,
            DESIGN_AREA_TEMPLATES_TAB.GOT_ALL_RESULTS.value,
          ),
        )}
      </>
    ) : (
      <NoDataView>
        {t(
          DESIGN_AREA_TEMPLATES_TAB.NO_TEMPLATES_AVAILABLE.key,
          DESIGN_AREA_TEMPLATES_TAB.NO_TEMPLATES_AVAILABLE.value,
        )}
      </NoDataView>
    );
  };

   const renderTabBody = () => {
    switch (selectedView) {
      case 'view-templates':
        return renderCategory();
      case 'view-template-pages':
        return selectedTemplate && renderTemplates();
      case 'view-search-template':
        return renderSearchView();
      default:
        break;
    }
  };

  const AddTagSuccess = (tagsList) => {
    store.set({ [COMPLEX_DOCUMENT_CONTEXT_KEYS.TAGS]: tagsList });
  }

  const renderModals = () => {
    switch (selectedAction) {
      case 'create-template':
        return (
          <CreateTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            onSucess={redirectToTemplate}
            categoryType="template"
          />
        );
      case 'delete-template':
        return (
          <DeleteTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            targetTemplate={selectedTemplate}
            categoryType="template"
            onSucess={onSuccessDeletion}
          />
        );

      case 'add-tag':
        return (
          <AddTagsModal
            visible={updateModalVisibility}
            onCancel={success => onSuccessAddition(success)}
            target={{ id: selectedTemplate.id, elementType: 'document', tags: tagList }}
            isEmail={false}
            isElement={false}
            isComplex={true}
            onSuccess={(tags) => AddTagSuccess(tags)}
          />
        );

      case 'preview-thumbnail':
        return (
          <ComplexPreviewModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            type={'document'}
            templateId={selectedTemplate.id}
            templateData={isMasterTab ? undefined : selectedTemplate}
            isMasterTemplate={isMasterTab}
          />
        );

      case 'template-locked':
        return (
          <Modal
            title={t(
              `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_MODAL_TITLE.key}`,
              TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_MODAL_TITLE.value,
            )}
            centered
            width="875px"
            visible={true}
            onCancel={() => setUpdateModalVisibility(false)}
            footer={[
              <Button key="back" onClick={() => setUpdateModalVisibility(false)}>
                {t(
                  `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.CANCEL_BUTTON.key}`,
                  TEMPLATE_LOCKED_BY_MODAL.CANCEL_BUTTON.value,
                )}
              </Button>,
              <Button key="submit" type="primary" onClick={() => setUpdateModalVisibility(false)}>
                {t(
                  `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.OK_BUTTON.key}`,
                  TEMPLATE_LOCKED_BY_MODAL.OK_BUTTON.value,
                )}
              </Button>,
            ]}
          >
            <ModalBody>
              <div className="warning-text">
                <span>
                  {' '}
                  {t(
                    `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED.key}`,
                    TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED.value,
                  )}{' '}
                </span>
                {lockedBy && (
                  <>
                    <span>
                      {t(
                        `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY.key}`,
                        TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY.value,
                      )}
                    </span>{' '}
                    <span className="text-highlighter"> {lockedBy.displayName}</span>
                    <span>
                      {' '}
                      {t(
                        `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY_TEMPLATE_NAME.key}`,
                        TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY_TEMPLATE_NAME.value,
                        { templateName: lockedBy.displayName },
                      )}{' '}
                    </span>
                  </>
                )}
              </div>
            </ModalBody>
          </Modal>
        );
      default:
        break;
    }
  };

  const masterFilterOption = async () => {
    const cancelTokenSource = axios.CancelToken.source();
    cancelTokenRef.current = cancelTokenSource;

    setInitialLoader(true);
    setFetchingLanguage(true);
    setFetchingCategories(true);

    try {
      const languageListResponse = await getMasterlanguageList();
      if (languageListResponse?.statusCode === 109 && languageListResponse?.data) {
        setLanguageList(languageListResponse.data);
      }
    } finally {
      setFetchingLanguage(false);
    };

    try {
      const DocumentByCategoryResponse = await getMasterDocumentByCategory(cancelTokenSource);
      if (DocumentByCategoryResponse?.statusCode === 707 && DocumentByCategoryResponse?.data) {
        setDefaultTemplates(DocumentByCategoryResponse.data);
        updateCategoryTemplates(DocumentByCategoryResponse.data, 'saveAllCategoryTemplates');
        setInitialLoader(false);
      }
    }
    catch (e) {
      setInitialLoader(false)
      console.error(e);
    }
      finally {
        setInitialLoader(false)
        cancelTokenRef.current = undefined;
        setFetchingCategories(false);
    }
  };

  
  const myDesignFilterOption = async () => {
    const cancelTokenSource = axios.CancelToken.source();
    cancelTokenRef.current = cancelTokenSource;

    setInitialLoader(true);
    setFetchingLanguage(true);
    setFetchingCategories(true);

    try {
      const languageListResponse = await getAllLanguage();
      if (languageListResponse?.statusCode === 109) {
        setLanguageList(languageListResponse.data);
      }
    } finally {
      setFetchingLanguage(false);
    };

    try {
      const response = await getAllDocumentsByCategories(
        false,
        true,
        templateType,
        isSelectionMode,
        '',
        cancelTokenSource,
      );
      if (response && response?.data) {
        setDefaultTemplates(response.data);
        updateCategoryTemplates(response.data, 'saveAllCategoryTemplates');
        setInitialLoader(false);
      }
    } 
    catch (e) {
      setInitialLoader(false)
      console.error(e);
    }
    finally {
      setInitialLoader(false);
      cancelTokenRef.current = undefined;
      setFetchingCategories(false);
    };
  };

  const selectDesignTabs = (key) => {
    updateCategoryTemplates('', 'emptyTemplate');
    if(cancelTokenRef.current){
      cancelTokenRef.current.cancel('Operation canceled.');
    }
    if (key === 'Master') {
      masterFilterOption();
    } else {
      myDesignFilterOption();
    }
    setSelectedView('view-templates');
    setSelectedTab(key);
    setFilterOption('All');
    setLanguageOption('All');
    setSearchKey('');
  };

  return (
    <TabMenuContainer
      style={
        isSelectionMode
          ? { marginBottom: 0, position: 'relative' }
          : {
            marginTop:
              selectedView === 'view-templates'
                ? '42px'
                : '125px',
          }
      }
      className={attachmentTemp && 'attachmentTemp'}   >

      {showPreviewLoader && <FullPageLoaderContainer>
        <Loader fullpage={true} />
      </FullPageLoaderContainer>}
      {!isSelectionMode && (
        <SearchNavWrapper className={activetabIndex === 0 ? 'showSearch' : 'hideSearch'}>
          {
            CurrentDesign === TEMPLATE_TYPE.DOCUMENT  &&
            <Tabs defaultActiveKey="MyDesigns" onChange={selectDesignTabs}>
              <TabPane tab={t(
                DESIGN_AREA_TEMPLATES_TAB.MY_DESIGNS_TABS_TITLE.key,
                DESIGN_AREA_TEMPLATES_TAB.MY_DESIGNS_TABS_TITLE.value,
              )} key="MyDesigns"></TabPane>
              <TabPane tab={t(
                DESIGN_AREA_TEMPLATES_TAB.MASTER_DESIGNS_TABS_TITLE.key,
                DESIGN_AREA_TEMPLATES_TAB.MASTER_DESIGNS_TABS_TITLE.value,
              )} key="Master"></TabPane>
            </Tabs>
          }
          {!initialLoader && <>{renderSearchBar()}</>}
        </SearchNavWrapper>
      )}
      {isSelectionMode && renderSearchBar()}
      {initialLoader && renderLoader()}
      <div>
        {!fetchingCategories && !initialLoader && (
          <div className={isSelectionMode ? 'categoryContainer' : ''} onScroll={onScroll}>
            {categoryTemplates?.length === 0 && renderEmptyView()}
            {categoryTemplates?.length > 0 && renderTabBody()}
          </div>
        )}
      </div>
      {!isSelectionMode && (
        <HelpGuideWrapper>
          <div className="help-container">
            <div
              className="help-action-btn"
              onClick={handleCreateTemplate}
            >
              {isCheckingLimit ? <Icon type='loading' /> : <Icon type="plus" />}{' '}
              {t(
                DESIGN_AREA_TEMPLATES_TAB.CREATE_NEW_TEMPLATE_BUTTON.key,
                DESIGN_AREA_TEMPLATES_TAB.CREATE_NEW_TEMPLATE_BUTTON.value,
              )}
            </div>
          </div>
        </HelpGuideWrapper>
      )}
      {!fetchingCategories && updateModalVisibility && selectedAction && renderModals()}
      <UpgradePlanModal 
        visible={showUpgradeModal}
        modalText={
          planName === 'Premium' ?
            t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
          : planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { documentLimit }) 
          : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
        }
        onCancel={() => setShowUpgradeModal(false)}
      />
    </TabMenuContainer>
  );
};

export default withTranslation(NAMESPACES)(ComplexTemplateTab);
